export default {
    namespaced: true,
    state: {
        downImgList: {},
        downList: {},
        versionType: "",
        versionPage: 1,
        versionScrollTop: 0,
    },
    mutations: {
        setVersionType(state: { versionType: any }, type: any) {
            state.versionType = type;
        },
        setVersionPage(state: { versionPage: any }, page: any) {
            state.versionPage = page;
        },
        setVersionScrollTop(state: { versionScrollTop: any }, top: any) {
            state.versionScrollTop = top;
        },
    },
    actions: {
        authVersionType(
            {
              commit,
            },
            type
          ) {
            commit("setVersionType", type);
          },
        authVersionPage(
            {
              commit,
            },
            page
          ) {
            commit("setVersionPage", page);
          },
          authVersionScrollTop(
            {
              commit,
            },
            top
          ) {
            commit("setVersionScrollTop", top);
          },
    },
}
